/**
 * @description TableSegment 表格展示列Segment常量配置
 */

import type { TTableSegment } from '../../types';
import type { ITableSegmentOption } from './types';

/**
 * 表格展示列Segment选项
 */
export const TABLE_SEGMENT_OPTIONS: ITableSegmentOption[] = [
  { value: 'metrics', i18nKey: 'dbi_casual_table_segment_metrics' },
  { value: 'topGames', i18nKey: 'dbi_casual_table_segment_top_games' },
  { value: 'risingGames', i18nKey: 'dbi_casual_table_segment_rising_games' },
];

/**
 * 默认表格展示列Segment值
 */
export const DEFAULT_TABLE_SEGMENT: TTableSegment = 'metrics';
